import React from 'react';
import { Square, Section } from '@grubhubprod/gh-cookbook-react/dist';

interface IPageSectionProps {
  children: JSX.Element | JSX.Element[];
}

export default function PageSection({
  children,
}: IPageSectionProps): JSX.Element {
  return (
    <Square
      dimension="1"
      bg="untintedBackground"
      borderBottomWidth="1px"
      borderBottomStyle="solid"
      borderBottomColor="lightLine"
    >
      <Section inset="md">{children}</Section>
    </Square>
  );
}
